import { Fragment, FunctionComponent } from 'react'
import { Global } from '@emotion/react'
import {
  ToastContainer as ConexaHeroToastContainer,
  EnvironmentIdentifier,
  Flex,
  Loader,
} from '@conexasaude/conexa-hero'
import { useThemeContext } from './theme/context/ThemeContext'
import useStyles from './styles/globalStyles'
import MainRoutes from './router/Router'
import NavBar from './components/NavBar'
import { ResetStyles } from '@conexasaude/styles'
import { IS_PRODUCTION, environmentMode } from './constants'
import '@conexasaude/conexa-hero/styles.css'
import { useGetConexaAdminPermissions } from './services/general/queries'

const App: FunctionComponent = () => {
  const { root } = useStyles()
  const { embed } = useThemeContext()
  const { conexaAdminPermissionsIsLoading } = useGetConexaAdminPermissions()

  if (conexaAdminPermissionsIsLoading) {
    return (
      <Flex justify="center" align="center">
        <Loader />
      </Flex>
    )
  }

  return (
    <Fragment>
      <ResetStyles />
      <Global styles={root} />
      <div className="environmentIdentifier">
        <EnvironmentIdentifier
          mode={environmentMode()}
          disabled={IS_PRODUCTION || embed?.value}
        />
      </div>
      <ConexaHeroToastContainer position="top-right" />

      {!embed?.value && <NavBar />}

      <MainRoutes />
    </Fragment>
  )
}

export default App
